import { KeyValue } from '@/main/models/common';
import { getTranslateByKey } from '@/main/services/utils';
import { z } from 'zod';

const requiredMsg = (fieldKey: string) =>
  getTranslateByKey('information.isRequired', true).replace(
    '{0}',
    getTranslateByKey(fieldKey)
  );

const keyValueSchema = z.custom<KeyValue>();

const requiredKeyValue = (fieldKey: string) =>
  keyValueSchema.nullable().refine((v): v is KeyValue => v !== null, {
    error: () => requiredMsg(fieldKey)
  });

export const approvalMatrixFormFilterSchema = z.object({
  country: requiredKeyValue('information.country'),
  insurer: keyValueSchema.nullable(),
  approvalMatrixType: keyValueSchema.nullable(),
  statusRegister: keyValueSchema.nullable(),
  matrixName: z.string().nullable()
});

export type IApprovalMatrixFilterForm = z.input<
  typeof approvalMatrixFormFilterSchema
>;
export type IApprovalMatrixFilterFormOutput = z.output<
  typeof approvalMatrixFormFilterSchema
>;

export const INITIAL_APPROVAL_MATRIX_FILTER_FORM: IApprovalMatrixFilterForm = {
  country: null,
  approvalMatrixType: null,
  statusRegister: null,
  insurer: null,
  matrixName: null
};
